import isFullArray from 'utils/predicates/array/isFullArray.util';

const fromDtoToItem = (item) => ({
  intentId: item?.intent_id,
  amountToRefund: item?.amount_to_refund,
});

const fromDtoToDepositRefundInfo = (items) => (isFullArray(items) ? items.map(fromDtoToItem) : []);

export default fromDtoToDepositRefundInfo;
